module.exports = __webpack_public_path__ + "media/pdfs/Prepworks-Mentorship-Brochure-2021-171e3aa0726df33d769a924de3bd356b.pdf";